/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostUploadPrintExampleMutationRequest, PostUploadPrintExampleMutationResponse, PostUploadPrintExample400 } from "../../models/PostUploadPrintExample";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPostUploadPrintExampleUrl() {
  const res = { method: 'POST', url: `/api/v1/print-examples` as const }  
  return res
}

/**
 * {@link /api/v1/print-examples}
 */
export async function postUploadPrintExample({ data }: { data: PostUploadPrintExampleMutationRequest }, config: Partial<RequestConfig<PostUploadPrintExampleMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  const formData = new FormData()
  if (requestData) {
   Object.keys(requestData).forEach((key) => {
     const value = requestData[key as keyof typeof requestData];
     if (typeof value === 'string' || (value as unknown) instanceof Blob) {
       formData.append(key, value as unknown as string | Blob);
     } else {
       formData.append(key, JSON.stringify(value));
     }
   })
  }  
  const res = await request<PostUploadPrintExampleMutationResponse, ResponseErrorConfig<PostUploadPrintExample400>, PostUploadPrintExampleMutationRequest>({ method : "POST", url : getPostUploadPrintExampleUrl().url.toString(), data : formData, ... requestConfig })  
  return res.data
}